import React from 'react'
// all modal in tsx file
import DeliveryPartyModal from 'src/components/molecules/Modals/DeliveryPartyModal/DeliveryPartyModal'
import ReminderOrderModal from 'src/components/molecules/Modals/ReminderOrderModal'
import ProductDetailsModal from 'src/components/molecules/Modals/ProductDetailModal'
import CartDrawer from 'src/components/molecules/Modals/CartDrawer'
import EatsFilterHandlerModal from 'src/components/molecules/Modals/EatsFilterHandlerModal'
import CartErrorModal from 'src/components/molecules/Modals/CartErrorModal'
import DateTimeSelectionModal from 'src/components/molecules/Modals/DateTimeSelectionModal'
import NeedHelpModal from 'src/components/molecules/Modals/NeedHelpModal'
import ContactRestaurantModal from 'src/components/molecules/Modals/ContactRestaurantModal'
import ContactLogisticModal from 'src/components/molecules/Modals/ContactLogisticModal'
import SelectCalendarModal from 'src/components/molecules/Modals/SelectCalendarModal'
import DownloadCalendarFileModal from 'src/components/molecules/Modals/DownloadCalendarFileModal'
import SuccessDownloadCalendarModal from 'src/components/molecules/Modals/SuccessDownloadCalendarModal'
import CreditCardAdditionalModal from 'src/components/molecules/Modals/CreditCardAdditionalModal'
import CreditCardDeletionModal from 'src/components/molecules/Modals/CreditCardDeletionModal'
import CreditCardChooserModal from 'src/components/molecules/Modals/CreditCardChooserModal'
import CheckoutPromotionModal from 'src/components/molecules/Modals/CheckoutPromotionModal'
import CheckoutFailedCardPromotionsModal from 'src/components/molecules/Modals/CheckoutPromotionModal/CheckoutFailedCardPromotionsModal'
import CheckoutPromoRemovalModal from 'src/components/molecules/Modals/CheckoutPromotionModal/CheckoutPromoRemovalModal'
import PickupStoreSelectionModal from 'src/components/molecules/Modals/PickupStoreSelectionModal'
import PickupDeliverySelectionModal from 'src/components/molecules/Modals/PickupDeliverySelectionModal'
import DeliverySelectAddressModal from 'src/components/molecules/Modals/DeliverySelectAddressModal'
import MobileLanguageDrawer from 'src/components/molecules/Modals/MobileLanguageDrawer'
import LanguageSelectionModal from 'src/components/molecules/Modals/LanguageSelectorModal'
import VoucherDetailsModal from 'src/components/molecules/Modals/VouchersSelectorModal/VoucherDetailsModal'
import VouchersSelectorModal from 'src/components/molecules/Modals/VouchersSelectorModal/VouchersSelectorModal'
import DeliveryTrackingModal from 'src/components/molecules/Modals/DeliveryTrackingModal'
import RefreshModal from 'src/components/molecules/Modals/RefreshModal'
import CheckoutErrorDialog from 'src/components/molecules/Modals/CheckoutErrorDialog'
import ClearCartConfirmationModal from 'src/components/molecules/Modals/ClearCartConfirmationModal'
import CheckoutExitConfirmationModal from 'src/components/molecules/Modals/CheckoutExitConfirmationModal'
import DeleteAddressModal from 'src/components/molecules/Modals/DeleteAddressModal'
import AddressEditorModal from 'src/components/molecules/Modals/AddressEditorModal'
import PromotionDetailsModal from 'src/components/molecules/Modals/PromotionDetailsModal'
import ErrorModal from 'src/components/molecules/Modals/ErrorModal'
import MobileSideNavigation from 'src/components/molecules/Modals/MobileSideNavigation'
import AccountChooserModal from 'src/components/molecules/Modals/AccountChooserModal'
import LogInModal from 'src/components/molecules/Modals/LogInModal'
import SignUpModal from 'src/components/molecules/Modals/SignUpModal'
import PasswordResetModal from 'src/components/molecules/Modals/PasswordResetModal'
import ChangePasswordModal from 'src/components/molecules/Modals/ChangePasswordModal'
import PasswordResetConfirmationModal from 'src/components/molecules/Modals/PasswordResetConfirmationModal'
import ForeignPhoneNumberModal from 'src/components/molecules/Modals/ForeignPhoneNumberModal'
import ShareAppModal from 'src/components/molecules/Modals/ShareAppModal'
import IframeModal from 'src/components/molecules/Modals/IframeModal'
// TODO: Use 'reselect' for mapStateToProps & mapDispatchToProps functions

export default React.memo(() => (
  <React.Fragment>
    <AccountChooserModal />
    <LogInModal />
    <SignUpModal />
    <PasswordResetModal />
    <PasswordResetConfirmationModal />
    <ChangePasswordModal />
    <AddressEditorModal />
    <DeleteAddressModal />
    <MobileSideNavigation />
    <ErrorModal />
    <PromotionDetailsModal />
    <EatsFilterHandlerModal />
    <ReminderOrderModal />
    <DeliveryPartyModal />
    <ProductDetailsModal />
    <CartDrawer />
    <CartErrorModal />
    <DateTimeSelectionModal />
    <NeedHelpModal />
    <ContactRestaurantModal />
    <ContactLogisticModal />
    <SelectCalendarModal />
    <DownloadCalendarFileModal />
    <SuccessDownloadCalendarModal />
    <CreditCardAdditionalModal />
    <CreditCardDeletionModal />
    <CreditCardChooserModal />
    <CheckoutPromotionModal />
    <CheckoutPromoRemovalModal />
    <CheckoutFailedCardPromotionsModal />
    <CheckoutPromotionModal.SummaryModal />
    <CheckoutPromotionModal.PromotionItemModal />
    <CheckoutPromotionModal.CheckoutFailedPromotionModal />
    <PickupStoreSelectionModal />
    <PickupDeliverySelectionModal />
    <DeliverySelectAddressModal />
    <MobileLanguageDrawer />
    <LanguageSelectionModal />
    <VoucherDetailsModal />
    <VouchersSelectorModal />
    <DeliveryTrackingModal />
    <RefreshModal />
    <CheckoutErrorDialog />
    <ClearCartConfirmationModal />
    <CheckoutExitConfirmationModal />
    <ForeignPhoneNumberModal />
    <ShareAppModal />
    <IframeModal />
  </React.Fragment>
))
